import { TOCSidebarProps } from '@/modules/core/components/TOCSidebar/TOCSidebar.types';
import { PLAN_MODULES } from '@/modules/plan/plan.constants';

export const planConfigModuleNames = {
  [PLAN_MODULES.PRIMARY_DEFINITION]: 'Primary Plan Definition',
  [PLAN_MODULES.COVERAGE]: 'Coverage',
  [PLAN_MODULES.ACCOUNT_FOUNDING]: 'Account Funding',
  [PLAN_MODULES.ELIGIBLE_SERVICES]: 'Eligible Services',
  [PLAN_MODULES.ACTIVITY_LOG]: 'Activity Log',
  // [PLAN_MODULES.PAYMENT_RULES]: 'Payment Rules',
  [PLAN_MODULES.FINAL_SETUP]: 'Final Setup',
  [PLAN_MODULES.DANGER_ZONE]: 'Danger Zone',
} as const;

export const usePlanModules = (exclude?: string[]): TOCSidebarProps['stepsMap'] => {
  return Object.keys(planConfigModuleNames).reduce((map, anchorId) => {
    if (exclude && exclude.includes(anchorId)) {
      return map;
    }
    return {
      ...map,
      [anchorId]: {
        title: planConfigModuleNames[anchorId],
      },
    };
  }, {});
};
